import { EnvironmentConfig } from './environment-d'
import { VERSION } from './version'


export const environment: EnvironmentConfig = {
  version: VERSION,
  production: true,
  env: 'stage',
  TAPI: 'https://stage.api.tokeet.com',
  apps: {
    checklist: {
      theme: 'checklist-theme',
      origin: 'https://stage.reset.usechecklist.com/',
      signupUrl: 'http://stage.register.usechecklist.com/',
      loginUrl: 'https://stage.app.usechecklist.com/login',
      autologinUrl: 'https://stage.app.usechecklist.com/login#token=',
      appearance: 'legacy',
      snackBarPositionH: 'center',
      snackBarPositionV: 'bottom',
      faviconUrl: '/assets/favicons/checklist.ico',
      supportEmail: 'support@tokeet.com',
    },
    rategenie: {
      theme: 'rategenie-theme',
      origin: 'https://stage.reset.rategenie.io/',
      signupUrl: 'http://stage.register.rategenie.io/',
      loginUrl: 'http://stage2.app.rategenie.io/login',
      autologinUrl: 'http://stage2.app.rategenie.io/login?token=',
      appearance: 'outline',
      snackBarPositionH: 'left',
      snackBarPositionV: 'bottom',
      faviconUrl: '/assets/favicons/rategenie.ico',
      supportEmail: 'support@tokeet.com',
    },
    sympl: {
      theme: 'sympl-theme',
      origin: 'https://stage.reset.sympl.cm/',
      signupUrl: 'https://stage.register.sympl.cm/',
      loginUrl: 'https://stage.app.sympl.cm/login',
      autologinUrl: 'https://stage.app.sympl.cm/login?token=',
      appearance: 'legacy',
      snackBarPositionH: 'left',
      snackBarPositionV: 'bottom',
      faviconUrl: '/assets/favicons/sympl.ico',
      supportEmail: 'support@tokeet.com',
    },
    tokeet: {
      theme: 'tokeet-theme',
      origin: 'https://stage.reset.tokeet.com/',
      signupUrl: 'https://stage.register.tokeet.com/',
      loginUrl: 'https://stage.tv3.tokeet.com/login',
      autologinUrl: 'https://stage.tv3.tokeet.com/login?token=',
      appearance: 'legacy',
      snackBarPositionH: 'right',
      snackBarPositionV: 'top',
      faviconUrl: '/assets/favicons/tokeet.ico',
      supportEmail: 'support@tokeet.com',
    },
    webready: {
      theme: 'webready-theme',
      origin: 'https://stage.reset.usewebready.com/',
      signupUrl: 'https://stage.register.usewebready.com/',
      loginUrl: 'https://stage.app.usewebready.com/login',
      autologinUrl: 'https://stage.app.usewebready.com/login?token=',
      appearance: 'outline',
      snackBarPositionH: 'center',
      snackBarPositionV: 'bottom',
      faviconUrl: '/assets/favicons/webready.ico',
      supportEmail: 'support@usewebready.com',
    },
    owners: {
      theme: 'owners-theme',
      origin: 'https://stage.reset.ownercenter.net/',
      signupUrl: 'https://stage.register.ownercenter.net/',
      loginUrl: 'https://stage2.app.ownercenter.net/login',
      autologinUrl: 'https://stage2.app.ownercenter.net/login?token=',
      appearance: 'outline',
      snackBarPositionH: 'left',
      snackBarPositionV: 'bottom',
      faviconUrl: '/assets/favicons/owners.png',
      supportEmail: 'support@ownercenter.net',
    },
    signature: {
      theme: 'signature-theme',
      origin: 'https://stage.reset.usesignature.com/',
      signupUrl: 'https://stage.register.usesignature.com/',
      loginUrl: 'https://stage.app.usesignature.com/login',
      autologinUrl: 'https://stage.app.usesignature.com/login?token=',
      appearance: 'outline',
      snackBarPositionH: 'left',
      snackBarPositionV: 'bottom',
      faviconUrl: '/assets/favicons/signature.ico',
      supportEmail: 'support@tokeet.com',
    },
  }
}
